import React, { useEffect } from 'react';
import styled from 'styled-components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { StyledAddIcon } from '../../../../Common/SvgIcon/CommonSvgIcons';
import { useState } from 'react';
import Toggle from './Toggle';
import Input from './Input';
import ItemList from '../ToggleList/ToggleList';
import { useDispatch, useSelector } from 'react-redux';
import { getKeywordTrends, setKeywordErrorHomePage } from '../../../../store/redux/slices/homePageSlice';

const Wrapper = styled.div`
  //margin: 100px;
  // width: 100%;

  border-radius: ${(props) => props?.isHomePage ? '5px' : '15px'};
  border: 1px solid #a2a2a2;
  min-height: ${(props) => props?.isHomePage ? '20px' : '40px'};
  padding:${(props) => props?.isHomePage ? '5px 20px' : '7px 21px'};

  font-family: inherit;
  font-weight: 500;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  position:${(props) => props?.isHomePage && props?.openLayout ? 'absolute' : ''} ;
  width: ${(props) => props?.isHomePage && props?.openLayout ? 'max-content' : ''} ;
  max-width: ${(props) => props?.isHomePage && props?.openLayout ? '350px' : ''} ;
  z-index:${(props) => props?.isHomePage && props?.openLayout ? '1000' : ''} ; 
  right: ${(props) => props?.isHomePage && props?.openLayout ? '0px' : ''} ;

  ${(p) =>
    p.openLayout === 'true'
      ? 'min-height:200px; justify-content:start;padding:20px;'
      : ''};

  // plus and arrow down icon container
  & > :nth-child(1) {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > :nth-child(2) {
      cursor: pointer;
      ${(p) => (p.openLayout === 'true' ? 'display:none;' : '')};
      // color: #353cf7;
      color: var(--Headlines, rgba(42, 136, 107, 1));
    }

    //Arrow button styles
    & > :nth-child(3) {
      ${(p) => (p.openLayout === 'true' ? 'transform: rotate(180deg);' : '')};
    }
  }

  //Add + button styles
  & > :nth-child(2) {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: ${(props) => (props.channel == 'facebook' || props.channel == 'YouTube' ? '0px' : props?.isHomePage ? '10px' : '20px')};
    padding-bottom: ${(props) =>
    props.channel == 'facebook' || props.channel == 'YouTube' ? '0px' : props?.isHomePage ? '15px' : '40px'};

    & > button {
      text-align: center;
      width:${(props) => props?.isHomePage ? '90px' : '132px'} ;
      height: ${(props) => props?.isHomePage ? '27px' : '39px'};
      border-radius: 40px;
      font-size: ${(props) => props?.isHomePage ? '11px' : '16px'};
      // background: #353cf7;
      background: linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%);
      color: #fff;
      outline: none;
      border: none;

      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;

      & > svg {
      width:${(props) => props?.isHomePage ? '14px' : '1em'};
      height:${(props) => props?.isHomePage ? '14px' : '1em'};
      }
    }
  }
`;

const PlaceholderWrapper = styled.div`
  width: 83%;
  text-align: left;
  color: #000;
  font-size:${(props) => props?.isHomePage == true ? '10px' : '15px'};
  font-family: inherit;
  line-height: 20px;
  overflow-wrap: break-word;
  word-break: break-word;
  margin-right:${(props) => props?.isHomePage == true ? '10px' : '0px'}; 
  & > span {
    color: #636363;
    font-weight: 400;
    text-transform: capitalize;

  }

  & > span[alt='innerCombinator'] {
    color: #636363;
  }

  & > span[alt='outerCombinator'] {
    // color: #353cf7;
      color: var(--Headlines, rgba(42, 136, 107, 1));
  }
`;
const StyledIconSpan = styled.span`

  margin-right:${(props) => props?.isHomePage == true ? '5px' : '0px'}; 
& > svg {

width:${(props) => props?.isHomePage ? '15px' : '1em'} ;
height: ${(props) => props?.isHomePage ? '15px' : '1em'} ;
}
`;
const CardContainer = styled.div`
  width: 85%;
  border-radius: 10px;
  background: rgb(240, 255, 240);
  padding: 30px 20px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  position: relative;
`;

const SideLine = styled.div`
  position: absolute;
  bottom: -88px;
  right: ${(props) => props?.isHomePage ? '-18px' : '-20px'};

  height: 110px;
  width: 18px;

  border: 1px solid #222;
  border-left: 0;
`;

const QueryContainer = styled.div`
  width: 100%;
  & > * {
    margin-bottom: ${(props) => props?.isHomePage ? '40px' : '60px'};
  }

  & > :last-child {
    margin-bottom: 20px;
  }
`;

const ArrowSpan = styled.span`
  position: relative;
  color: #636363;
  margin-right: -10px;

  cursor: pointer;
  & > svg {

width:${(props) => props?.isHomePage ? '15px' : '1em'} ;
height: ${(props) => props?.isHomePage ? '15px' : '1em'} ;
}
`;
const ApplyWrapper = styled.div`

    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
      & > button {
          text-align: center;
      width: 90px;
      height: 27px;
      border-radius: 40px;
      font-size: 11px;
      font-family:inherit;
      background:${(p) => p?.is_custom ? p.is_custom : 'linear-gradient(95.02deg, rgb(160, 217, 37) -65.35%, rgb(0, 106, 104) 100%)'} ;
      color: rgb(255, 255, 255);
      outline: none;
      border: none;
      cursor: pointer;
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      gap: 10px;

      & > svg {
      width:13px;
      }
      }

`;
const ErrorSpan = styled.span`
  color: red;
  display: flex;
  margin-top: 0px;
  margin-left: 10px;
  font-size:${(props) => props.isHomePage ? '10px !important' : '14px'};
`;

const ItemListWrapper = styled.div`
  width: 400px;
  height: 250px;
  padding: 7px 21px;
  align-items: center;
  margin: 0px 0px 0px 0px;
  //gap: 10px;
  flex-shrink: 0;
`;

const NoiseLabel = styled.span`
  color: #8e8e8e;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
`;

const ErrorMessage = styled.div`
  padding: 2px 10px;

  color: #d74748;
  font-family: inherit;
  font-size:${(props) => props.isHomePage ? '10px !important' : '14px'};
  font-weight: 500;
  line-height: normal;
`;

const InputContainer = ({
  channel,
  sideLine,
  query,
  index,
  addNewInputToGroup,
  removeInputFromGroup,
  updateInputValue,
  updateInputKeywordType,
  toggleIndividualGroupCombinator,
  toggleGroupCombinator,
  keywordType,
  exclude,
  is_custom,
  isHomePage=false
}) => {
  const keywords = query.group;

  return (
    <CardContainer>
      {keywords.map((keyword, i) => (
        <Input
          key={i}
          exclude={exclude}
          inputData={{
            index: i,
            inputChangeHandler: (i, value) => updateInputValue(index, i, value),
            removeNewKeyword: (indexToRemove) =>
              removeInputFromGroup(index, indexToRemove),
            addNewKeyword: () => addNewInputToGroup(index, i),
            changeKeywordType: (newKeywordType, i) =>
              updateInputKeywordType(index, i, newKeywordType),
            keyword,
          }}
          keywordType={keywordType}
          isHomePage={isHomePage}
        />
      ))}
      {(channel != 'facebook' || channel == 'YouTube' || isHomePage) && (
        <Toggle
          toggleValue={query.combinator}
          is_custom={is_custom}
          toggleIndividualGroup={() =>!isHomePage && toggleIndividualGroupCombinator(index)}
          isHomePage={isHomePage}
        />
      )}

      {sideLine && (
        <Toggle
        is_custom={is_custom}
          pos={{ bottom: isHomePage ? '-25px' : '-42px', right: isHomePage ? '-25px' : '-40px' }}
          toggleValue={query.combinatorWithNextGroup}
          toggleIndividualGroup={() =>!isHomePage &&  toggleGroupCombinator(index)}
          isHomePage={isHomePage}
        />
      )}
      {sideLine && <SideLine isHomePage={isHomePage} />}
    </CardContainer>
  );
};

const TempComp = ({
  setKeyWordError,
  keywordType,
  exclude,
  placeholder = 'Enter Keywords',
  setQueryArrays,
  queryArrays,
  error,
  channel,
  isHomePage = false,
  showApply = false,
  handleReset = () => { },
  handleKeywordQuerySubmit = () => { },
  returnQueryString = () => { },
  keywordErrorHomePage=''
}) => {

  const { personalDetailsData } = useSelector((state) => state.tenantSetting);
  let col = personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'linear-gradient(180deg, #0B7263 0%, #5AA942 100%)';
  const [openLayout, setOpenLayout] = useState(false);
  const [emptyErrorMessage, setEmptyErrorMessage] = useState('');
  const [keywordMessage, setKeywordMessage] = useState('');
  const dispatch = useDispatch()
  const ALERT_ALLOWED_TYPES = ['Hashtags', 'Mentions'];

  const deepClone = (obj) => JSON.parse(JSON.stringify(obj));
  const exclusion = [
    // { id: 1, name: 'Select all', isActive: false },
    { id: 2, name: 'Sweepstakes', isActive: false },
    { id: 3, name: 'Sales Listings', isActive: false },
    { id: 4, name: 'Coupons', isActive: false },
    { id: 5, name: 'Supplemental Income', isActive: false },
    { id: 6, name: 'Cryptocurrency', isActive: false },
    // Add more items as needed
  ];
  const addNewQueryGroup = () => {
    // to add new group to queryArrays
    if(isHomePage){
      setQueryArrays([
        ...queryArrays,
        {
          group: [{ value: '', keywordType: 'Word' }],
          combinator: 'AND',
          combinatorWithNextGroup: 'OR',
        },
      ]);
    }else{
      setQueryArrays([
        ...queryArrays,
        {
          group: [{ value: '', keywordType: 'Word' }],
          combinator: 'OR',
          combinatorWithNextGroup: 'OR',
        },
      ]);
    }
    
  };

  const addNewInputToGroup = (index, group_index) => {
    // to add new input to specific group
    const temp = deepClone(queryArrays);

    // const temp = [...queryArrays];
    const tempValue = temp[index].group[group_index].value;
    if (
      tempValue === '' ||
      (tempValue.length === 1 &&
        (tempValue.charAt(0) === '#' || tempValue.charAt(0) === '@'))
    ) {
      setEmptyErrorMessage('Please Enter a keyword');
    } else if (
      exclude &&
      (tempValue.length === 2 || tempValue.length === 1) &&
      (tempValue.charAt(1) === '#' ||
        tempValue.charAt(1) === '@' ||
        tempValue.charAt(0) === '-')
    ) {
      setEmptyErrorMessage('Please Enter a keyword');
    } /* else if (
      !exclude &&
      temp[group_index].group[index].keywordType === 'Word' &&
      !tempValue.match(/^[A-Za-z]+$/)
    ) {
      setKeywordMessage('Please enter a valid word or Phrase');
    } */ else {
      if(channel == 'Alert'){
        
      temp[index].group.push({ value: "'#'", keywordType: 'Hashtags' });
      }else{
      temp[index].group.push({ value: '', keywordType: 'Word' });
      }
      setQueryArrays(temp);
      dispatch(setKeywordErrorHomePage(''))
      setEmptyErrorMessage('');

      setKeywordMessage('');
    }
  };

  const removeInputFromGroup = (group_index, inputIndex) => {
    // to remove input from specific group
    const temp = deepClone(queryArrays);
    // const temp = [...queryArrays];
      dispatch(setKeywordErrorHomePage(''))
    setEmptyErrorMessage('')
    // if only one group and only one input is present then reset the queryArrays
    if (temp[group_index].group.length === 1 && temp.length === 1) {
      setQueryArrays([
        {
          group: [{ value: '', keywordType: 'Word' }],
          combinator: 'OR',
          combinatorWithNextGroup: 'OR',
        },
      ]);
    }
    // if only one input is present in a group then remove the group from queryArrays
    else if (temp[group_index].group.length === 1) {
      temp.splice(group_index, 1);
      setQueryArrays(temp);
    }
    // else remove the input from the specific group
    else {
      temp[group_index].group.splice(inputIndex, 1);
      setQueryArrays(temp);
    }
  };

  // to update input value
  const updateInputValue = (group_index, index, value) => {
    setKeyWordError('')
    // const temp = [...queryArrays];
    const temp = deepClone(queryArrays);
    //temp[inputIndex].keywordType = keywordType;
    if (temp[group_index].group[index].keywordType === 'Phrase') {
      temp[group_index].group[index].value = value;
    } else if (
      temp[group_index].group[index].keywordType === 'Mentions' ||
      temp[group_index].group[index].keywordType === 'Hashtags'
    ) {
      let hashVal =
        temp[group_index].group[index].keywordType === 'Mentions' ? '@' : '#';
      let hashMentVal = '';
      if (hashVal === '@') {
        hashMentVal = value
          .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
          .replace(/['"]/g, '')
          .replace(/[@#]/g, '') // Remove any remaining unmatched quotes
          .trim();
        temp[group_index].group[index].value = `${hashVal}${hashMentVal
          ?.trim()
          ?.split(' ')
          ?.join('')}`;
      } else {
        if (!exclude) {
          hashMentVal = value
            .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
            .replace(/['"]/g, '')
            .replace(/[@#]/g, '') // Remove any remaining unmatched quotes
            .trim();
          temp[group_index].group[index].value =
            (channel === 'twitter' || channel == 'YouTube' || channel === 'facebook' || channel == 'Alert')
              ?  '#' + hashMentVal?.trim()?.split(' ')?.join('') 
              : hashMentVal?.trim()?.split(' ')?.join('');
        } else {

          hashMentVal = value
            .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
            .replace(/['"]/g, '')
            .replace(/[@#-]/g, '') // For Twitter Exclusion
            .trim();
          temp[group_index].group[index].value =
            (channel === 'twitter' || channel === 'YouTube' || channel === 'facebook' || channel == 'Alert')
              ? '-' + '#' +
              hashMentVal?.trim()?.split(' ')?.join('')
            
              : hashMentVal?.trim()?.split(' ')?.join('');
        }
      }
    } else if (temp[group_index].group[index].keywordType === 'Word') {
      let hashMentVal = value
        .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
        .replace(/['"]/g, '')
        .replace(/[@]/g, '') // Remove any remaining unmatched quotes
        .trim();
      temp[group_index].group[index].value = hashMentVal
        ?.trim()
        ?.split(' ')
        ?.join('');
    } else {
      let hashMentVal = value
        .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
        .replace(/['"]/g, '')
        .replace(/[@]/g, '') // Remove any remaining unmatched quotes
        .trim();
      temp[group_index].group[index].value = hashMentVal
        ?.trim()
        ?.split(' ')
        ?.join('');
    }
    /*  if(exclude && temp[group_index].group[index].keywordType === 'Word') {
      let temp1 = value.charAt(0);
      temp1 = '-';
      temp[group_index].group[index].value = temp1 + value;

    } */
    if (temp[group_index].group[index].keywordType === 'Phrase' && !exclude) {
      const tt = value.replaceAll("'", '');
      temp[group_index].group[index].value = `'${tt}'`;
    }
    if (temp[group_index].group[index].keywordType === 'Phrase' && exclude) {
      const tt = value.replaceAll("'", '');
      if (tt?.length < 2) {
        temp[group_index].group[index].value = `'${tt}'`;
      } else {
        var swapStr = `'${tt}'`;
        swapStr = swapStr[1] + swapStr[0] + swapStr?.slice(2);
        temp[group_index].group[index].value = swapStr;
      }
    }
    // if (
    //   temp[group_index].group[index].keywordType === 'Word' &&
    //   value.charAt(value.length - 1) === ' '
    // ) {
    //   return;
    // }

    if (
      (exclude && value.trim().length === 1) ||
      value.trim() == '' ||
      (temp[group_index].group[index].keywordType === 'From User' &&
        value.trim()?.length < 5) ||
      (temp[group_index].group[index].keywordType === 'To User' &&
        value.trim()?.length < 3)
    ) {
      updateInputKeywordType(
        group_index,
        index,
        temp[group_index].group[index].keywordType
      );
    }
    if (exclude && temp[group_index].group[index].keywordType === 'Word') {
      const trimmedValue = value.trim();
      const updatedValue = trimmedValue.replaceAll('-', '');
      temp[group_index].group[index].value =
        updatedValue.length > 0
          ? '-' + updatedValue?.trim()?.split(' ')?.join('')
          : '';
    }
    setQueryArrays(temp);
    //setQueryArrays(temp);
    setEmptyErrorMessage('');
  };

  //to update keyword type
  const updateInputKeywordType = (group_index, index, newKeywordType) => {
    if (channel === 'Alert' && !ALERT_ALLOWED_TYPES.includes(newKeywordType)) {
    return; // 🚫 block other types
  }
    // let temp = [...queryArrays];
    const temp = deepClone(queryArrays);
    if (temp[group_index]?.group[index]?.keywordType === 'From User') {
      if (temp[group_index]?.group[index]?.value?.startsWith('from:')) {
        if (
          temp[group_index] &&
          temp[group_index].group &&
          temp[group_index].group[index] &&
          temp[group_index].group[index].value?.startsWith('from:')
        ) {
          temp[group_index].group[index].value =
            temp[group_index].group[index].value.slice(5);
        }
      }
    }
    if (temp[group_index]?.group[index]?.keywordType === 'To User') {
      if (temp[group_index]?.group[index]?.value?.startsWith('to:')) {
        if (
          temp[group_index] &&
          temp[group_index].group &&
          temp[group_index].group[index] &&
          temp[group_index].group[index].value?.startsWith('to:')
        ) {
          temp[group_index].group[index].value =
            temp[group_index].group[index].value.slice(3);
        }
      }
    }
    // if (temp[group_index]?.group[index]?.keywordType === 'From User') {
    //   if (temp[group_index]?.group[index]?.value?.startsWith('from:')) {
    //     if (
    //       temp[group_index] &&
    //       temp[group_index].group &&
    //       temp[group_index].group[index] &&
    //       temp[group_index].group[index].value?.startsWith('from:')
    //     ) {
    //       temp[group_index].group[index].value =
    //         temp[group_index].group[index].value.slice(5);
    //     }
    //   }
    // }
    if (
      newKeywordType == 'Word'
      // ["Word"].includes(
      //   temp[group_index].group[index].keywordType.trim()
      // )
    ) {
      let tempVal = temp[group_index]?.group[index]?.value

        .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
        .replace(/['"]/g, '') // Remove any remaining unmatched quotes
        .replace(/[@#]/g, '') // Remove hashtags and mentions
        .trim();
      tempVal = tempVal?.trim()?.split(' ')?.join('');
      temp[group_index].group[index].value = tempVal;
    }
    if (
      ['Hashtags', 'Mentions', 'From User', 'To User'].includes(
        newKeywordType // temp[group_index].group[index].keywordType.trim()
      )
    ) {
      let tempValue = temp[group_index]?.group[index]?.value
        .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
        .replace(/['"]/g, '')
        .replace(/[@#]/g, '') // Remove any remaining unmatched quotes
        .trim();
      temp[group_index].group[index].value = tempValue;
      // .substring(
      //   exclude ? 2 : 1
      // );
    } else if (exclude) {
      let tempValue = temp[group_index].group[index].value.trim();
      temp[group_index].group[index].value = tempValue.substring(1);
    }
    let hashMentVal = temp[group_index]?.group[index]?.value
      .replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
      .replace(/['"]/g, '')
      .replace(/[@#]/g, '') // Remove any remaining unmatched quotes
      .trim();
    if (newKeywordType.trim() === 'Hashtags') {
      temp[group_index].group[index].value =
         '#' + hashMentVal?.trim()?.split(' ')?.join('');
    } else if (newKeywordType.trim() === 'Mentions') {
      temp[group_index].group[index].value =
        '@' + hashMentVal?.trim()?.split(' ')?.join('');
    } else if (newKeywordType.trim() === 'From User') {
      if (
        temp[group_index].group[index].value === 'from' ||
        temp[group_index].group[index].value === 'rom:' ||
        temp[group_index].group[index].value === 'fom:' ||
        temp[group_index].group[index].value === 'frm:' ||
        temp[group_index].group[index].value === 'fro:'
      ) {
        temp[group_index].group[index].value = 'from:';
      } else {
        temp[group_index].group[index].value =
          'from:' + temp[group_index].group[index].value;
      }
    } else if (newKeywordType.trim() === 'To User') {
      if (
        temp[group_index].group[index].value === 'to' ||
        temp[group_index].group[index].value === 't:' ||
        temp[group_index].group[index].value === 'o:'
      ) {
        temp[group_index].group[index].value = 'to:';
      } else {
        temp[group_index].group[index].value =
          'to:' + temp[group_index].group[index].value;
      }
    } else if (newKeywordType.trim() === 'Phrase') {
      let tempValue = temp[group_index].group[index]?.value
        ?.replace(/^['"]|['"]$/g, '') // Remove leading and trailing matched quotes
        .replace(/[@#]/g, '') // Remove any remaining unmatched quotes
        .replace(/['"]/g, '');
      temp[group_index].group[index].value = `'${tempValue}'`;
    }

    if (exclude) {
      if (newKeywordType === 'Hashtags') {
        temp[group_index].group[index].value = temp[group_index].group[index].value?.replace(/[@-]/g, '')
      }
      temp[group_index].group[index].value =
        '-' + temp[group_index].group[index].value;
    }
    temp[group_index].group[index].keywordType = newKeywordType;
    setQueryArrays(temp);
  };

  // to toggle individual group combinator
  const toggleIndividualGroupCombinator = (index) => {
    const temp = deepClone(queryArrays);
    // const temp = [...queryArrays];
    if (temp[index].combinator === 'OR') {
      temp[index].combinator = 'AND';
    } else {
      temp[index].combinator = 'OR';
    }
    setQueryArrays(temp);
  };

  // to toggle group combinator
  const toggleGroupCombinator = (index) => {
    const temp = deepClone(queryArrays);
    if (temp[index].combinatorWithNextGroup === 'OR') {
      temp[index].combinatorWithNextGroup = 'AND';
    } else {
      temp[index].combinatorWithNextGroup = 'OR';
    }
    setQueryArrays(temp);
  };

  function formQueryString() {
    returnQueryString(formQueryString_InStringFormate);
    // To form query string
    let queryString = [];

    // temporary variables for individual group in query
    let temp;
    // Flag variables for checking string has at least one word
    let flag = false;
    for (let i = 0; i < queryArrays.length; i++) {
      temp = queryArrays[i].group;
      queryString.push(
        <React.Fragment key={i}>
          (&nbsp;
          {temp.map((item, index) => {
            if (item.value.length > 0) {
              flag = true;
              return (
                <React.Fragment key={index}>
                  {item.value}
                  {index + 1 !== temp.length && (
                    <span alt='innerCombinator'>
                      &nbsp;&nbsp;
                      {queryArrays[i].combinator}
                      &nbsp;&nbsp;
                    </span>
                  )}
                </React.Fragment>
              );
            }
            return null;
          })}
          &nbsp;)
          {i + 1 !== queryArrays.length && (
            <span alt='outerCombinator'>
              &nbsp;&nbsp;{queryArrays[i].combinatorWithNextGroup}&nbsp;&nbsp;
            </span>
          )}
        </React.Fragment>
      );
    }

    if (!flag) return false;
    return queryString;
  }
  function formQueryString_InStringFormate() {
    let queryString = [];
    let flag = false;
  
    for (let i = 0; i < queryArrays.length; i++) {
      const group = queryArrays[i].group;
      const combinator = queryArrays[i].combinator;
      let groupParts = [];
  
      let lastValueValid = false;
  
      for (let j = 0; j < group.length; j++) {
        const val = group[j].value?.trim();
        if (channel == 'Alert' && (val == '#' || val == '@')){
          return false
        }
  
        if (val?.length > 0) {
          
          // Check for invalid "#" keyword (e.g., only '#' or starts with '#' but no actual content)
          if ((val === '#' || /^'#'\s*$/.test(val)) || (val === '@' || /^@\s*$/.test(val)) || (val === "''" || /^'\s*'$/.test(val))) {
            return false;
          }
  
          flag = true;
          lastValueValid = true;
  
          let valueToPush = '';
          if (exclude) {
            if (val.includes('#')) {
              let tempStr = val.slice(2); // remove "-'"
              if (!tempStr || tempStr.trim() === '') return false;
              valueToPush = `-'${tempStr}'`;
            } else {
              valueToPush = val;
            }
          } else {
            if (val.includes('#')) {
              let keyword = val.replace(/^#+/, '').trim();
              if (!keyword) return false;
              valueToPush = `'${val}'`;
            } else {
              valueToPush = val;
            }
          }
  
          groupParts.push(valueToPush);
        } else {
          if (lastValueValid && j === group.length - 1) return false;
          if (!lastValueValid && group.length === 1) return false;
        }
      }
  
      if (groupParts.length === 0) return false;
  
      const groupString = `(${groupParts.join(` ${combinator} `)})`;
      queryString.push(groupString);
  
      const hasNextNonEmptyGroup = queryArrays
        .slice(i + 1)
        .some(g => g.group.some(item => item.value?.trim().length > 0));
  
      if (hasNextNonEmptyGroup) {
        queryString.push(queryArrays[i].combinatorWithNextGroup);
      }
    }
  
    if (!flag) return false;
  
    return queryString.join(' ');
  }
  
  
  
  
  
  useEffect(() => {
      // Don't reset if values already exist (edit mode)
      const hasAnyValue = queryArrays.some((i) =>
        i.group.some((val) => val.value && val.value.trim() !== '')
      );

      if (hasAnyValue) return; // ← This line skips the reset during edit mode

      let updatedQueryArrays = queryArrays.map((i) => {
        let { group } = i;
        group = group.map((val) => {
          return {
            ...val,
            keywordType: channel == 'Alert' ? 'Hashtags' : 'Word',
            value: val.value,
          };
        });
        return {
          ...i,
          group,
        };
      });

      setQueryArrays(updatedQueryArrays);
    }, [channel]); // Re-run when the channel changes

  /* function handleOpenLayout() {
    //console.log(formQueryString_InStringFormate())
    //setOpenLayout((prev) => !prev)
    if(exclude) {
      setOpenLayout((prev) => prev)
    } else {
      setOpenLayout((prev) => !prev)
    }/* else {
      setOpenLayout((prev) => prev)
    } */
  const handleCloseReset = () => {
    dispatch(setKeywordErrorHomePage(''))
    setOpenLayout(false)
    handleReset()
  }
  const handleSubmit = () => {
    if(formQueryString_InStringFormate()){
      dispatch(setKeywordErrorHomePage(''))
      setOpenLayout(false)
      handleKeywordQuerySubmit(formQueryString_InStringFormate())
    }else{
      
      dispatch(setKeywordErrorHomePage('Please specify Keywords'))
    }
  }
  return (
    <Wrapper openLayout={openLayout} channel={channel} isHomePage={isHomePage}>
      <div onClick={() => setOpenLayout((prev) => !prev)}>
        <PlaceholderWrapper isHomePage={isHomePage}>
          {formQueryString() || (
            <span data-testid='placeholder-text'>{placeholder}</span>
          )}
        </PlaceholderWrapper>
        <StyledIconSpan isHomePage={isHomePage}>{StyledAddIcon}</StyledIconSpan>
        <ArrowSpan isHomePage={isHomePage}>
          <KeyboardArrowDownIcon />
        </ArrowSpan>
      </div>

      {openLayout && (
        <div>
          <QueryContainer isHomePage={isHomePage}>
            {queryArrays.map((query, i) => (
              <InputContainer
                channel={channel}
                query={query}
                index={i}
                exclude={exclude}
                key={i}
                sideLine={queryArrays[i + 1] !== undefined ? true : false}
                addNewInputToGroup={addNewInputToGroup}
                removeInputFromGroup={removeInputFromGroup}
                updateInputValue={updateInputValue}
                updateInputKeywordType={updateInputKeywordType}
                toggleIndividualGroupCombinator={
                  toggleIndividualGroupCombinator
                }
                toggleGroupCombinator={toggleGroupCombinator}
                keywordType={keywordType}
                isHomePage={isHomePage}
                is_custom={col}
              />
            ))}
          </QueryContainer>
          {
            <ErrorSpan isHomePage={isHomePage}>
              {keywordErrorHomePage ? keywordErrorHomePage : emptyErrorMessage ? emptyErrorMessage : keywordMessage}
            </ErrorSpan>
          }
          {
            channel == 'Alert' ? 
            <></>
            :
            !showApply ?
              (channel != 'facebook' && channel != 'YouTube') && (<button onClick={addNewQueryGroup} style={{fontFamily:'inherit',background:col}}>Add {StyledAddIcon}</button>)

              :

              <ApplyWrapper is_custom={col}>
                {/* onClick={()=> setOpenLayout(false)} */}
                <button onClick={() => handleCloseReset()} style={{ background: 'white', color: 'black' }}>Reset</button>
                {(channel != 'facebook' || channel != 'YouTube' || isHomePage == true) && (
                  <button onClick={addNewQueryGroup}>Add {StyledAddIcon}</button>
                )}
                <button onClick={() => handleSubmit()}>Apply</button>
              </ApplyWrapper>
          }
        </div>
      )}
      {/* {exclude && openLayout && (
        <ItemListWrapper>
          <NoiseLabel>Exclude Noise</NoiseLabel>
          <ItemList items={exclusion} exclusion={true} />
        </ItemListWrapper>
      )} */}
      {error && <ErrorMessage isHomePage={isHomePage}>{error}</ErrorMessage>}
    </Wrapper>
  );
};

export default TempComp;
